angular.module('impactx.scrollMenu').directive('ixScrollMenu', function () {
    return {
        scope:
        {
            items: "=",
            scrollArea: "@" //if not set, #main-content will be used. Set it to md-dialog-content in md dialogs.
        },
        restrict: 'E',
        controller: "ScrollMenuCtrl",
        controllerAs: 'scrollMenuCtrl',
        replace: true,
        templateUrl: 'shared/scrollmenu/templates/scrollmenu.tmpl.html'
    }
});